import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { useGetAllCustomers } from '../../api/customer';
import { CustomerCenterTable } from './CustomerCenterTable';
import { SearchBar } from './SearchBar';
import './CustomerCenterPage.scss';
import { useTitle } from '../../hooks/useTitle.ts';

export const CustomerCenterPage = () => {
  useTitle('Customer Center - Immersive Homes');
  const [searchValue, setSearchValue] = useState('');
  const [lastEvaluatedKey, setLastEvaluatedKey] = useState<Record<
    string,
    object
  > | null>(null);

  const { data: customers, loading } = useGetAllCustomers(
    searchValue,
    JSON.stringify(lastEvaluatedKey)
  );

  const handleFetchMoreItems = () => {
    if (customers?.LastEvaluatedKey) {
      setLastEvaluatedKey(customers.LastEvaluatedKey);
    }
  };

  const handleSearchChange = (value: string) => {
    setSearchValue(value);
  };
  const reset = () => {
    setLastEvaluatedKey(null);
    setSearchValue('');
  };

  const LoadingScreen: React.FunctionComponent = () => {
    return (
      <Box className="loading-screen">
        <CircularProgress sx={{ marginRight: '8px' }} />
        <Typography>Loading Customers...</Typography>
      </Box>
    );
  };

  return (
    <Box id="customer-center">
      <Box className="text-container">
        <Typography variant="h1">Customer Center</Typography>
        <Typography>View Customer Details and access their portals.</Typography>
      </Box>
      <Box className="button-container">
        <Button onClick={reset} className="">
          Reset
        </Button>
        <Box sx={{ minWidth: 240 }}>
          <FormControl fullWidth></FormControl>
        </Box>
        <SearchBar value={searchValue} onChange={handleSearchChange} />
      </Box>
      <>
        {!loading && customers ? (
          <>
            <Box sx={{ height: '100%' }}>
              <CustomerCenterTable customers={customers} />
              {customers.LastEvaluatedKey && (
                <Button onClick={handleFetchMoreItems}>Load More</Button>
              )}
            </Box>
          </>
        ) : (
          <LoadingScreen />
        )}
      </>
    </Box>
  );
};
